/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UpsertWorkUnitsSettingsRequestBody = {
  /**
   * Organization whose settings to replace.
   */
  organizationId: string;
  /**
   * Maximum work-units evaluations reserved across the organization each UTC day. 0 disables scoring as surely as the switch.
   */
  workUnitsDailyCap: number;
  /**
   * Whether work-units chat analysis is enabled.
   */
  workUnitsEnabled: boolean;
};

/** @internal */
export type UpsertWorkUnitsSettingsRequestBody$Outbound = {
  organization_id: string;
  work_units_daily_cap: number;
  work_units_enabled: boolean;
};

/** @internal */
export const UpsertWorkUnitsSettingsRequestBody$outboundSchema: z.ZodMiniType<
  UpsertWorkUnitsSettingsRequestBody$Outbound,
  UpsertWorkUnitsSettingsRequestBody
> = z.pipe(
  z.object({
    organizationId: z.string(),
    workUnitsDailyCap: z.int(),
    workUnitsEnabled: z.boolean(),
  }),
  z.transform((v) => {
    return remap$(v, {
      organizationId: "organization_id",
      workUnitsDailyCap: "work_units_daily_cap",
      workUnitsEnabled: "work_units_enabled",
    });
  }),
);

export function upsertWorkUnitsSettingsRequestBodyToJSON(
  upsertWorkUnitsSettingsRequestBody: UpsertWorkUnitsSettingsRequestBody,
): string {
  return JSON.stringify(
    UpsertWorkUnitsSettingsRequestBody$outboundSchema.parse(
      upsertWorkUnitsSettingsRequestBody,
    ),
  );
}
